import React, { useEffect, useState } from 'react';

import { EpisodeListMainContainer } from './EpisodesListContainerStyle';
import { BreakPointsConfig } from '../../components/rails/railsHelper';
import { getEpisodeData } from '../../services/apiRequests/TvShowDetailsPage/EpisodeQueryService';
import { Episode } from '../../services/GraphQL/Queries/types';
import { HTTP_HEADER_KEYS } from '../../utils/constants/HttpMethodsConstants';
import { TV_SHOW_PAGE_CONSTANTS } from '../../utils/constants/TvShowDetailsPageConstants';
import fetchNextPage from '../../utils/IntersectionObserverHelper';
import WdsThumbnail from '../@wds/wdsThumbnail/wdsThumbnail';

interface EpisodesListContainerProps {
  episodesList: Episode[];
  seasonId: string;
  totalEpisodes?: number;
}

const EpisodesListContainer = ({
  episodesList,
  seasonId,
  totalEpisodes
}: EpisodesListContainerProps) => {
  const [pageCount, setPageCount] = useState<number>(2);
  const [episodeCount, setEpisodeCount] = useState<Episode[]>(episodesList);

  useEffect(() => {
    setEpisodeCount(episodesList);
  }, [episodesList]);

  useEffect(() => {
    fetchNextPage(
      () => {
        if (totalEpisodes && (pageCount - 1) * 25 <= totalEpisodes) {
          getEpisodeDataOnScroll(pageCount);
        }
      },
      false,
      TV_SHOW_PAGE_CONSTANTS.EPISODE_CONTAINER
    );

    return () => {
      fetchNextPage(() => null, true, TV_SHOW_PAGE_CONSTANTS.EPISODE_CONTAINER);
    };
  }, [pageCount]);

  const episodePageBreakPointConfig: BreakPointsConfig = {
    xl: 4,
    default: 4,
    lg: 4,
    md: 3,
    sm: 2
  };

  const getEpisodeDataOnScroll = async (pageCount: number) => {
    const header = [HTTP_HEADER_KEYS.X_ACCESS_TOKEN];
    const data = await getEpisodeData(
      seasonId,
      pageCount,
      header,
      TV_SHOW_PAGE_CONSTANTS.EPISODE_COUNT
    );
    if (data && Object.keys(data).length) {
      setEpisodeCount((prevEpisodes) => [
        ...prevEpisodes,
        ...(data?.contents as Episode[])
      ]);
      setPageCount((pageCount) => pageCount + 1);
    }
  };
  return (
    <EpisodeListMainContainer
      className="episodes-container"
      data-testid="episodeListContainer">
      {episodeCount &&
        episodeCount.map((contentDetails: Episode, index: number) => {
          if (!Object.keys(contentDetails).length) return <></>;
          return (
            <div
              key={contentDetails.id}
              data-testid={`episodeListCount-${index}`}>
              <WdsThumbnail
                details={contentDetails}
                index={index}
                breakPointsConfig={episodePageBreakPointConfig}
              />
            </div>
          );
        })}
    </EpisodeListMainContainer>
  );
};

export default EpisodesListContainer;
